import { z } from "zod/v4";

import { HistoryDtoSchema } from "../../../dtos/history";

export const GetHistoryPathParamSchema = z.object({
  experienceId: z.uuid(),
});

export type GetHistoryPathParamType = z.infer<typeof GetHistoryPathParamSchema>;

export const GetHistoryResponseBodySchema = z.object({
  history: HistoryDtoSchema.array(),
});

export type GetHistoryResponseBodyType = z.infer<
  typeof GetHistoryResponseBodySchema
>;
